import { Component, OnInit } from '@angular/core';
import { Conjoint } from 'model/model.conjoint';
import { Prescription } from 'model/prescription';
import { AdminService } from '../../../services/admin';

@Component({
  selector: 'app-medicament-consommer-par-agent',
  templateUrl: './medicament-consommer-par-agent.component.html',
  styleUrls: ['./medicament-consommer-par-agent.component.scss']
})
export class MedicamentConsommerParAgentComponent implements OnInit {
  agentIm: String;
  agent: Conjoint = new Conjoint(null);
  prescriptions: Array<Prescription> = new Array<Prescription>();
  modeh: number;
  mode_menu:number=1;
  
  id_agent_actuel: any;
  loginuserCMSActuel: any;
  listeFamille: any[];
  constructor(public adminService: AdminService) {
    //give IM agent
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
    this.agentIm = this.id_agent_actuel

    // test login admin
    this.loginuserCMSActuel = this.adminService.getLoginUseCMS();
    if(this.loginuserCMSActuel=="cms_daf"){
      this.mode_menu=2;
     }else{
       this.mode_menu=1;
     }
   }

  ngOnInit() {
   // this.agentIm = "";
   this.recupererAgentFamille(); 
    this.adminService.getConjoinsParIm(this.agentIm)
    .subscribe(data => {
      this.agent.agent_nom = data.agent_nom;
      this.agent.agent_prenom = data.agent_prenom;
      this.agent.id = data.id;
      this.getStatistiquePrescriptionAgent();
    }, err => {
      console.log(err);
    })
  

  }


  //le agent tonga de apoitra par defaut
  //afaka manao rechercha ny zanany sy izy 
  //le traitement ny vady tsy apoitra

  recupererAgentFamille() {
    this.adminService.getlisteFamille(this.id_agent_actuel)
      .subscribe(data => {
        console.log("akory aby nareo")
        if (data.length ==0 ) {              
          this.listeFamille = []
        } else if (data.length !=0){
          this.listeFamille = data;        
          console.log("akory aby nareo" + this.listeFamille)
        }

      }, err => {

      })
  }



  onKey(event: any) {
    console.log(event.target.value);
    let key2 = event.target.value;
    let count = event.target.value.length;
    console.log(count);
    this.agent = new Conjoint(null);
    if (count >= 6) {
      console.log(event.target.value.length);
      this.recupererInfoAgent();
    }
  }

  recupererInfoAgent() {
    this.adminService.getConjoinsParIm(this.agentIm)
      .subscribe(data => {
        this.agent.agent_nom = data.agent_nom;
        this.agent.agent_prenom = data.agent_prenom;
        this.agent.id = data.id;
      }, err => {
        console.log(err);
      })
  }


  recuperermedicamentConsommer(im_agent_select:any){
    this.adminService.getConjoinsParIm(im_agent_select)
      .subscribe(data => {
        this.agent.agent_nom = data.agent_nom;
        this.agent.agent_prenom = data.agent_prenom;
        this.agent.id = data.id;
        this.getStatistiquePrescriptionAgent()
      }, err => {
        console.log(err);
      })
  }




  getStatistiquePrescriptionAgent() {
    this.adminService.getStatistiquePrescriptionParAgent(this.agent).subscribe(data => {
      this.prescriptions = data;
      this.modeh = 1;
    }, err => {

    });
  }


  getLibelleLocalite(id) {
    return this.adminService.getLibelleLocalite(id);
  }

}
